<dx-box *ngIf="!isSmallScreen" class="brand-image-container" direction="row">
  <dxi-item *ngIf="!brandImage" baseSize="auto" class="cc-header-icon">
    <img class="cc-header-brand-icon" [src]="logoImage" alt="CiraConnect" />
  </dxi-item>
  <dxi-item
    baseSize="auto"
    [ngClass]="{ 'cc-header-brand-icon-small': isSmallScreen }"
  >
    <div *dxTemplate="let data of 'item'">
      <div *ngIf="brandImage">
        <img
          class="cc-header-brand-icon"
          [src]="brandImage"
          alt="{{ brandAltText }}"
          [title]="brandAltText"
        />
      </div>
    </div>
  </dxi-item>
  <dxi-item baseSize="auto">
    <div *dxTemplate="let data of 'item'">
      <div *ngIf="isInternalUser && !isSmallScreen">
        <label class="cc-header-title">{{ title }}</label>
      </div>
    </div>
  </dxi-item>
</dx-box>
